module.exports = __webpack_public_path__ + "img/744.2732ad3e.jpg";